import { TextBox } from '@apply/components';
import { useCustomPaymentAddressCity } from '../../../../../fields/CustomPaymentFields';

interface CityProps {
    customPaymentId: string;
    required?: boolean;
    validator?: React.ReactNode;
}

export const City: React.FC<CityProps> = ({ customPaymentId, required = false, validator }) => {
    const label = 'City';
    const [city, set_city] = useCustomPaymentAddressCity(customPaymentId);
    return (
        <>
            <TextBox
                id='city'
                value={city}
                onChange={(value) => set_city(value)}
                label={label}
                placeholder='Hamilton'
                required={required}
                width={'100%'}
                maxLength={50}
                validator={validator}
            />
        </>
    );
};
